import * as React from 'react'
import {ITableProps, IAsyncTableProps} from '../../interfaces/models'
import {connect} from 'react-redux'
import {IAppStore} from '../../../interfaces/reducers'
import {IFeatureTablesDispatcher} from '../../interfaces/dispatchers'

interface ParentProps {
  stringsStyle?: React.CSSProperties
  tools: Array<(props: ITableProps, key: any) => JSX.Element>
  tableId: string
  featureTableDispatcher: IFeatureTablesDispatcher
}

interface OwnProps {
  tableProps: {[key: string]: ITableProps}
}

interface DispatchProps {}

type Props = OwnProps & DispatchProps & ParentProps

interface State {
  inputPage?: number
  tableProps?: ITableProps
}

export class ReduxAsyncPagination extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    const tableProps = props.tableProps[props.tableId]
    this.state = {
      tableProps: tableProps,
      inputPage: tableProps.asyncProps ? tableProps.asyncProps.page + 1 : 1
    }
    this.applyInput = this.applyInput.bind(this)
  }
  componentDidUpdate(prevProps: Props) {
    if (prevProps.tableProps !== this.props.tableProps || prevProps.tableId !== this.props.tableId) {
      const tableProps = this.props.tableProps[this.props.tableId]
      this.setState({
        ...this.state,
        tableProps: tableProps,
        inputPage: tableProps.asyncProps ? tableProps.asyncProps.page + 1 : 1
      })
    }
  }
  protected getCountString(tableProps: ITableProps, asyncTableProps: IAsyncTableProps): string {
    let startIndex = 0
    let count = asyncTableProps.recordsCount
    if (count === undefined) {
      count = tableProps.data ? tableProps.data!.length : 0
    }

    let pageSize = 0
    if (tableProps.pageSize != undefined && asyncTableProps.page != undefined && tableProps.data != undefined) {
      pageSize = tableProps.pageSize
      startIndex = tableProps.pageSize * asyncTableProps.page
    }
    let countString = ''
    if (count) {
      if (asyncTableProps.pages == 1) {
        countString = `Общо ${count} броя`
      } else {
        countString = `${startIndex + 1}-${startIndex + pageSize} от ${count}`
      }
    }
    return countString
  }

  applyInput(asyncTableProps: IAsyncTableProps) {
    const newPage = this.state.inputPage ? this.state.inputPage - 1 : 0
    if (newPage != asyncTableProps.page) {
      this.props.featureTableDispatcher.changePage(this.props.tableId, newPage)
    }
  }
  protected getNavigation = (tableProps: ITableProps, asyncTableProps: IAsyncTableProps): JSX.Element | null => {
    if (!asyncTableProps.pages || asyncTableProps.pages < 2) {
      return null
    }
    return (
      <div style={{minWidth: '160px', width: '160px', display: 'flex'}}>
        <button
          type="button"
          onClick={() => {
            if (asyncTableProps.page < 1) return
            this.props.featureTableDispatcher.changePage(this.props.tableId, asyncTableProps.page - 1)
          }}
          disabled={asyncTableProps.page < 1}
        >
          {tableProps.previousText}
        </button>
        <div style={{minWidth: '100px', display: 'flex'}}>
          <input
            style={{width: '50%'}}
            type={asyncTableProps.page || asyncTableProps.page == 0 ? 'number' : 'text'}
            onChange={e => {
              let val = parseFloat(e.target.value)
              if (val > asyncTableProps.pages) {
                val = asyncTableProps.pages
              }
              if (val < 1) {
                val = 1
              }
              this.setState({...this.state, inputPage: val})
            }}
            value={this.state.inputPage ? this.state.inputPage : ''}
            onBlur={() => this.applyInput(asyncTableProps)}
            onKeyPress={e => {
              if (e.which === 13 || e.keyCode === 13) {
                this.applyInput(asyncTableProps)
              }
            }}
          />
          <span style={{width: '20%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
            {tableProps.ofText}
          </span>
          <span style={{width: '30%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
            {asyncTableProps.pages || 1}
          </span>
        </div>
        <button
          type="button"
          onClick={() => {
            if (asyncTableProps.page + 2 > asyncTableProps.pages) return
            this.props.featureTableDispatcher.changePage(this.props.tableId, asyncTableProps.page + 1)
          }}
          disabled={asyncTableProps.page + 2 > asyncTableProps.pages}
        >
          {tableProps.nextText}
        </button>
      </div>
    )
  }
  getMoreTools(tableProps: ITableProps) {
    const tools: Array<JSX.Element> = []

    this.props.tools.forEach((t, i) => {
      tools.push(<React.Fragment key={i}>{t(tableProps, i)}</React.Fragment>)
    })

    return tools
  }
  render() {
    if (!this.state.tableProps || !this.state.tableProps.asyncProps) {
      return null
    }
    const countString = this.getCountString(this.state.tableProps, this.state.tableProps.asyncProps)
    return (
      <div style={{display: 'flex', textAlign: 'center', justifyContent: 'space-between'}}>
        {this.getNavigation(this.state.tableProps, this.state.tableProps.asyncProps)}
        {this.state.tableProps.selectedIds ? (
          <div style={this.props.stringsStyle}>{`${
            Object.keys(this.state.tableProps.selectedIds).length
          } избрани`}</div>
        ) : null}
        {countString ? <div style={this.props.stringsStyle}>{countString}</div> : null}
        {this.getMoreTools(this.state.tableProps)}
      </div>
    )
  }
}

const mapStateToProps = (state: IAppStore) => ({
  tableProps: state.data.featureTables
})

export default connect<OwnProps, DispatchProps, ParentProps>(mapStateToProps)(ReduxAsyncPagination)
